module.exports = __webpack_public_path__ + "img/img-ffp-west.fc854e89.png";